export default __webpack_public_path__ + "static/media/tireOrderingIcon.be92e8b8.svg";